import React from 'react'
import { AppTableColumnProps } from './AppTableColumn'
import { AppTable } from 'qcc'
import { appTree } from 'utils'
import {AppFilter} from 'qcc'

export interface AppTableApi{
    api?: (data: any) => Promise<{list?: any[]; total?: number}>
    // apiPath?: string
    onBeforeApi?:(data?: any) => boolean 
    queryData?:any
    queryDataList?:AppFilter[]
    queryMode?:number   // 默认为1 为list模式 2为老模式，自行在后台解析
}

export interface AppTableProps extends AppTableApi {
    paging?: true | false
    pageSize?: number
	currentId?: number
	dataSource?: any[]
    keyName?: string
    parentKeyName?:string
	selected?: any[]
	rowClick?: (data: any) => void
    expandLevel?:number
    leftFixIndex?:number
    rightFixIndex?:number
    orderBy?:string
    sqlId?:string
    exportRef?:(ref?:AppTable)=>void
}

interface TableArea{
    columns:AppTableColumnProps[]
    width:number
    columsWidth:number
}

export interface TableLayout {
    tree?: boolean
    multSelect?: boolean
    left?:TableArea
    main?:TableArea
    right?:TableArea
    width?: number
    height?: number
    headerHeight?:number
    xScroll?:number   
    yScroll?:number  
}

interface AppTableServerProps extends AppTableProps{
    children?: React.ReactNode
}

export class AppTableServer {
    private layout:TableLayout;
    private id:string;
    private parentId:string;
    private dataList:any[];

    constructor(props:AppTableServerProps){
        let newPorps = {...props,leftFixIndex:props.leftFixIndex||-1,rightFixIndex:props.rightFixIndex||-1}
        this.layout = initLayout(newPorps);
        this.id = props.keyName || 'id'
        this.parentId = props.parentKeyName || 'parentId'
    }

    handleList = (list:any[],bgnIndex: number,expandLevel:number,selected?:any[]) =>{
        let {tree} = this.layout;
        let treeList :any[]= tree?appTree.list(list,this.parentId,this.id):[];   
        let tempList = tree ? handlTableTreeDataList(treeList,expandLevel) : handlTableDataList(list,bgnIndex);

        // 处理默认的选中
        selected = selected || [];
        if(selected.length > 0){
            let isIds = typeof(selected[0]) === 'number' || typeof(selected[0]) === 'string';
            // 先处理最末级和非树形的
            tempList = tempList.map((tempData:any)=>{
                 
                let checked = isIds? selected.filter(e => e === tempData[this.id]).length >0
                :selected.filter(e => e[this.id] === tempData[this.id]).length >0
                return {...tempData,_table_checked:checked};
            })
            // 处理树形结构，非末级数据
            if(tree){
                let endItemList = tempList.filter(e => e._tree_end);
                tempList = tempList.map((treeData:any)=>{
                    if(treeData._tree_end) return {...treeData};
                    let endChildren = endItemList.filter(e => e._tree_code.indexOf(treeData._tree_code)===0)||[];
                    let checkedValue = calcFaitherCheckValue(endChildren);
                    return {...treeData,_table_checked:checkedValue===treeFatherCheck.all,_table_indeterminate:checkedValue===treeFatherCheck.half};
                })
            }
        }

        this.dataList = tempList;
        return this.dataList;
    }



    handleTreeClick = (eventData: any) =>{
        eventData._table_expand_icon === 'caret-right'? this.handleTreeExpand(eventData):this.handleTreeShrink(eventData)
        return this.dataList;
    }

    handleTreeExpand = (eventData:any) =>{
        this.dataList.map((data:any)=>{
            if(data[this.id] === eventData[this.id]){
                data._table_expand_icon = 'caret-down';
            }else if(data[this.parentId] === eventData[this.id]){
                data._table_hidden = false;
            }
        })
    }

    handleTreeShrink = (eventData:any) =>{
        let treeCode = eventData._tree_code
        this.dataList.map((data:any)=>{
            if(data[this.id] === eventData[this.id]){
                data._table_expand_icon = 'caret-right';
            }else if (data._tree_code.indexOf(treeCode)===0){
                data._table_hidden = true
                data._table_expand_icon = 'caret-right'
            }

        })
    }

    handleCheckAll = (checked: boolean) =>{
        this.dataList.map((data:any)=>{
            data._table_checked = checked;
            data._table_indeterminate = false;
        })
        return [...this.dataList];
    }

    handleCheck = (eventData:any,checked: boolean) =>{
        let {tree} = this.layout;

        this.dataList.map((data:any)=>{
            if(data[this.id] === eventData[this.id] || (tree && data._tree_code.indexOf(eventData._tree_code)===0)){
                data._table_checked = checked
            }
        })
        
        if(tree){
            this.dataList.map((data:any)=>{
                if(!data._tree_end){
                    let endChildren = this.dataList.filter(e => e._tree_code.indexOf(data._tree_code)===0 && e._tree_end)||[];
                    let checkedValue = calcFaitherCheckValue(endChildren);
                    data._table_checked = (checkedValue===treeFatherCheck.all)
                    data._table_indeterminate = (checkedValue===treeFatherCheck.half)
                }
            })
        }

        return [...this.dataList];
    }

    handleUpdateData =(dataIndex: number, field: string, value: any) =>{
        this.dataList[dataIndex][field] = value
		return this.dataList;
    }

    getAllCheckedValue = () =>{
        return calcFaitherCheckValue(this.dataList);
    }

    getLayout = ()=>{
        return this.layout;
    }

    setLayout = (appTable:HTMLDivElement) =>{

        console.log('appTable:',appTable.clientHeight)
        console.log('appTable:',appTable.clientHeight)

    }

}


const initLayout = (props:AppTableServerProps) =>{
    let {children,leftFixIndex,rightFixIndex} =props
    let tree = false;
    let multSelect=false;
    let left = {columns:[] as AppTableColumnProps[], width:-1,columsWidth:0} as TableArea;
    let main = {columns:[] as AppTableColumnProps[], width:-1,columsWidth:0} as TableArea;
    let right = {columns:[] as AppTableColumnProps[], width:-1,columsWidth:0} as TableArea;
    

    React.Children.toArray(children).forEach((column:any,index:number)=>{
        let columnProps = {...column.props} as AppTableColumnProps
        multSelect = multSelect || columnProps.field === '__table_check_box'
        tree = columnProps.expand || tree

        if(index<=leftFixIndex){
            columnProps ={...columnProps,width:columnProps.width||100};
            left.columns.push(columnProps);
            left.columsWidth = left.columsWidth + columnProps.width
        }else if (index >= rightFixIndex && rightFixIndex>0){
            columnProps ={...columnProps,width:columnProps.width||100};
            right.columns.push(columnProps);
            right.columsWidth = right.columsWidth + columnProps.width
        }else{
            columnProps = { ...columnProps, width: columnProps.width || 0 }
        }

        main.columns.push(columnProps)
        // 没有设置宽度则默认为100，方便后续计算表格相对容器是自适应还是固定宽度 超出容器则为固定宽度，否则为全屏
        main.columsWidth = main.columsWidth+(columnProps.width===0?100:columnProps.width)
    })  
    
    return {tree,
        multSelect,
        left,
        main,
        right,
        height:0,
        width:0,
        headerHeight:36,
        xScroll:0,
        yScroll:0
    } as TableLayout
}


const handlTableDataList = (dataList:any[],bgnIndex: number) =>{
    return dataList.map((data: any, index:number) => {
        return {...data,
            _table_index:bgnIndex + index + 1,
            _table_checked:false,
            _table_hidden:false
        };
    })
}

const handlTableTreeDataList = (dataList:any[],expandLevel:number) =>{
    return dataList.map((data: any, index:number) => {
        return {...data,
            _table_index:index + 1,
            _table_checked:false,
            _table_hidden:data._tree_level > expandLevel,
            _table_indeterminate :false,
            _table_expand_icon:data._tree_level < expandLevel ? 'caret-down' : 'caret-right'
        };
    })
}

// 树形结构的父级的选中状态,枚举状态
const treeFatherCheck={
    empty:0,    
    all:1,
    half:2
}
const calcFaitherCheckValue = (dataList: any[])=> {
    let allCount = dataList.length
    if (allCount === 0) return treeFatherCheck.empty;

    let checkedCount =  dataList.filter(e => e._table_checked).length;
    if (checkedCount === 0) return treeFatherCheck.empty;

    if(allCount===checkedCount) return treeFatherCheck.all;

    return treeFatherCheck.half;
}


export function handleScroll({ target }: any) {

    let {scrollLeft,scrollTop,scrollWidth,clientWidth} = target
    let offsetWidth = scrollWidth - clientWidth
  
    let parentElement = target.parentElement.parentElement
  
    let mainHeader = parentElement.querySelector('.app-table-header-inner')
    let leftBody = parentElement.querySelector('.app-table-body-left-fixed')
    let rightBody = parentElement.querySelector('.app-table-body-right-fixed')
  
   
    if (mainHeader) mainHeader.scrollLeft = scrollLeft
    if (leftBody) {
      leftBody.scrollTop = scrollTop
      // 如果是滚动条在最左边
      leftBody.parentElement.style.display = scrollLeft === 0 ? 'none' : 'inherit'
    }
    if (rightBody) {
      rightBody.scrollTop = scrollTop
      // 如果是滚动条在最右边
      rightBody.parentElement.style.display = scrollLeft === offsetWidth ? 'none' : 'inherit'
    }
  }


// interface ApptableData extends any{
//     _table_index?:number
//     _table_checked?:boolean
//     _table_hidden?:boolean
//     _table_indeterminate?:boolean
//     _table_expand_icon?:string
//     _tree_code?:string
//     _tree_level?:number
//     _tree_end?:boolean
// }
  


// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableServer.tsx